import React from 'react';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CloseIcon from '@mui/icons-material/Close';
import { Shape } from 'Custom-Mindmap';
import { TRANSPARENT_COLOR } from '../Shapes/shapeCatalog';
import { typeLabelOf } from './nodeProps';
import styles from './NodeProperties.module.css';

const PREVIEW_SIZE = 26;
const PLAIN_TEXT = 'text';

/** A live thumbnail: the node's shape in its draft fill, or a "T" for plain text. */
const NodePreview = ({ values }) => (
    <span className={styles.preview} aria-hidden="true">
        {values.type === PLAIN_TEXT ? (
            <span className={styles.previewText} style={{ color: values.textColor }}>T</span>
        ) : (
            <Shape
                type={values.type}
                width={PREVIEW_SIZE}
                height={PREVIEW_SIZE}
                color={values.isFilled ? values.fill : TRANSPARENT_COLOR}
            />
        )}
    </span>
);

/** Preview, the node's type over "Shape • Unsaved", then delete and close. */
const PanelHeading = ({ values, isDirty, onDelete, onClose }) => (
    <div className={styles.header}>
        {values && <NodePreview values={values} />}
        <div className={styles.title}>
            <span className={styles.titleMain}>{values ? typeLabelOf(values.type) : 'Properties'}</span>
            {values && (
                <span className={styles.titleSub}>
                    {values.type === PLAIN_TEXT ? 'Text' : 'Shape'}
                    {isDirty && <span className={styles.unsaved}>Unsaved</span>}
                </span>
            )}
        </div>
        {values && (
            <>
                <button
                    type="button"
                    className={`${styles.headerBtn} ${styles.deleteBtn}`}
                    onClick={onDelete}
                    aria-label="Delete node"
                    title="Delete node"
                >
                    <DeleteOutlineIcon />
                </button>
                <span className={styles.headerDivider} aria-hidden="true" />
            </>
        )}
        <button type="button" className={styles.headerBtn} onClick={onClose} aria-label="Close" title="Close">
            <CloseIcon />
        </button>
    </div>
);

export default PanelHeading;
